import React, { useContext } from 'react';
import { Route } from 'react-router-dom';
import Routes from '../../routes/Routes';
import ThemeProvider from '../../providers/ThemeProvider';
import { useSelector } from 'react-redux';
import LoadingBackground from '../../components/CircularLoader';
import InternalErrorView from '../../components/500';
import ThemeContext from '../../contexts/ThemeContext';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { useTranslation } from 'react-i18next';

function App() {
  const isRedirectServerErrorPage = useSelector((state) => state.ui.isRedirectServerErrorPage);
  const themeContext = useContext(ThemeContext);

  

  return (
    <ThemeProvider>
      <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY} scriptProps={{ async: true }}>
        {isRedirectServerErrorPage && (<InternalErrorView code={"5OO"} themeConfig={themeContext} />)}
        {!isRedirectServerErrorPage && (
          <Route path="/" component={Routes}></Route>
        )}
      </GoogleReCaptchaProvider>
    </ThemeProvider >
  );
}

export default App;
